import { normalizeSubscriptionTier } from '#pplx/frontend/auth/subscriptionTier.js';
// TODO(ENT-6348): Purge these aliases in final cleanup after old API writers retire.
export function normalizeEnterpriseMember(member) {
    const tier = normalizeSubscriptionTier(member.subscription_tier);
    return tier ? { ...member, subscription_tier: tier } : member;
}
export function normalizeEnterpriseOrganization(organization) {
    const settings = organization.settings;
    if (settings &&
        !('viewer_tier_enabled' in settings) &&
        typeof settings.basic_tier_enabled === 'boolean') {
        return {
            ...organization,
            settings: { ...settings, viewer_tier_enabled: settings.basic_tier_enabled },
        };
    }
    return organization;
}
export function normalizeEnterpriseTierPreview(preview) {
    return preview.update_type === 'update_to_basic'
        ? { ...preview, update_type: 'update_to_viewer' }
        : preview;
}
//# sourceMappingURL=enterpriseResponse.js.map